module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-suroviny"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("translate")('Make your own Haffit')))]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStepValid() && this.tryEscape),
      expression: "!isStepValid() && this.tryEscape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isStepValid() && this.tryEscape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n                " + _vm._s(_vm._f("translate")('At least one ingredient that does not contain an allergen must be selected from each category.')) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.existValidOption) ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("translate")('We are not able to offer you a feed for you pet')) + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.typSlozkyItems) ? _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "summary-subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Only with us can you directly affect the composition of the food. Choose your meat and side dish.')) + "\n        ")]), _vm._v(" "), (_vm.akcniKombinace.length > 0) ? _c('div', {
    staticClass: "suroviny-akce"
  }, [(_vm.akcniKombinace) ? _c('div', {
    staticClass: "suroviny-skupina"
  }, [_c('h2', [_vm._v(_vm._s(_vm._f("translate")('Sale combinations')))]), _vm._v(" "), _c('div', {
    staticClass: "form-radios"
  }, _vm._l((_vm.akcniKombinace), function(item) {
    return _c('div', {
      key: item.id,
      class: {
        'form-type-radio': true
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.zvolenaAkcniKombinace),
        expression: "zvolenaAkcniKombinace"
      }],
      attrs: {
        "type": "radio",
        "id": 'kombinace-' + item.id
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.zvolenaAkcniKombinace, item)
      },
      on: {
        "change": [function($event) {
          _vm.zvolenaAkcniKombinace = item
        }, _vm.akcniKombinaceChange]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'kombinace-' + item.id
      }
    }, [_c('div', {
      staticClass: "ico"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.nazev_cj))]), _vm._v(" "), (item.popis_cj.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.popis_cj)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sale"
    }, [_vm._v(_vm._s(_vm._f("translate")('Sale')))])])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "suroviny"
  }, [(_vm.typSlozkyItems[0]) ? _c('div', {
    staticClass: "suroviny-skupina"
  }, [_c('h2', [_vm._v(_vm._s(_vm.typSlozkyItems[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isMasovaValid() && this.tryEscape
    }
  }, _vm._l((_vm.typSlozkyItems[0].items), function(item) {
    return _c('div', {
      key: item.id,
      class: {
        'form-type-radio': true, 'form-type-radio-disabled': item.alergic || item.status == 0, 'pripravujeme': item.status == 0
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[0].id_typ_slozky]),
        expression: "mazlicek.suroviny.slozky[typSlozkyItems[0].id_typ_slozky]"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.typSlozkyItems[0].id_typ_slozky,
        "id": item.id,
        "disabled": item.alergic || item.status == 0
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[0].id_typ_slozky], item.id)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.mazlicek.suroviny.slozky, _vm.typSlozkyItems[0].id_typ_slozky, item.id)
        }, _vm.slozkaChange]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e(), _vm._v(" "), (item.alergic) ? _c('div', {
      staticClass: "suroviny-alergic-info"
    }, [_c('div', {
      staticClass: "suroviny-alergic-info-icn"
    }), _vm._v(" "), _c('div', {
      staticClass: "suroviny-alergic-info-desc"
    }, [_vm._v(_vm._s(_vm._f("translate")('Includes allergen')))])]) : _vm._e(), _vm._v(" "), (item.status == 0) ? _c('div', {
      staticClass: "suroviny-pripravujeme-info"
    }, [_c('div', {
      staticClass: "suroviny-pripravujeme-info-icn"
    }), _vm._v(" "), _c('div', {
      staticClass: "suroviny-pripravujeme-info-desc"
    }, [_vm._v(_vm._s(_vm._f("translate")('Coming soon')))])]) : _vm._e(), _vm._v(" "), (item.filename) ? _c('img', {
      attrs: {
        "src": _vm.getSlozkaImageUrl(item.filename)
      }
    }) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.typSlozkyItems[1]) ? _c('div', {
    staticClass: "suroviny-skupina"
  }, [_c('h2', [_vm._v(_vm._s(_vm.typSlozkyItems[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isPrilohaValid() && this.tryEscape
    }
  }, _vm._l((_vm.typSlozkyItems[1].items), function(item2) {
    return _c('div', {
      key: item2.id,
      class: {
        'form-type-radio': true, 'form-type-radio-disabled': item2.alergic || item2.status == 0, 'pripravujeme': item2.status == 0
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[1].id_typ_slozky]),
        expression: "mazlicek.suroviny.slozky[typSlozkyItems[1].id_typ_slozky]"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.typSlozkyItems[1].id_typ_slozky,
        "id": item2.id,
        "disabled": item2.alergic || item2.status == 0
      },
      domProps: {
        "value": item2.id,
        "checked": _vm._q(_vm.mazlicek.suroviny.slozky[_vm.typSlozkyItems[1].id_typ_slozky], item2.id)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.mazlicek.suroviny.slozky, _vm.typSlozkyItems[1].id_typ_slozky, item2.id)
        }, _vm.slozkaChange]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item2.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item2.title))]), _vm._v(" "), (item2.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item2.description)
      }
    }) : _vm._e(), _vm._v(" "), (item2.alergic) ? _c('div', {
      staticClass: "suroviny-alergic-info"
    }, [_c('div', {
      staticClass: "suroviny-alergic-info-icn"
    }), _c('div', {
      staticClass: "suroviny-alergic-info-desc"
    }, [_vm._v(_vm._s(_vm._f("translate")('Includes allergen')))])]) : _vm._e(), _vm._v(" "), (item2.status == 0) ? _c('div', {
      staticClass: "suroviny-pripravujeme-info"
    }, [_c('div', {
      staticClass: "suroviny-pripravujeme-info-icn"
    }), _c('div', {
      staticClass: "suroviny-pripravujeme-info-desc"
    }, [_vm._v("\n                                  " + _vm._s(_vm._f("translate")('Coming soon')))])]) : _vm._e(), _vm._v(" "), (item2.filename) ? _c('img', {
      attrs: {
        "src": _vm.getSlozkaImageUrl(item2.filename)
      }
    }) : _vm._e()])])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 9
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514ec588","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/09Suroviny.vue
// module id = 548
// module chunks = 1